import axios from "axios";
import Api from "../../utils/config/api";
import { toastr } from "react-redux-toastr";

export const getPlacesFromGoogle = (
  reqBody,
  fieldMask = "places.id,places.displayName,places.formattedAddress"
) => {
  const endpoint = `https://places.googleapis.com/v1/places:searchText`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-Goog-Api-Key": import.meta.env.VITE_GOOGLE_PLACES_API_KEY || "",
      "X-Goog-FieldMask": fieldMask,
    },
  };

  return new Promise((resolve, reject) => {
    axios
      .post(endpoint, reqBody, config)
      .then((res) => resolve(res?.data?.places))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.errors?.join(", ") ||
            "Failed to search images on unsplash"
        );
        return reject(err);
      });
  });
};

export const getPlacesFromOla = (input) => {
  const endpoint = `https://api.olamaps.io/places/v1/autocomplete?input=${input}&api_key=${import.meta.env.VITE_OLA_API_KEY}`;

  return new Promise((resolve, reject) => {
    axios
      .get(endpoint)
      .then((res) => resolve(res?.data?.predictions))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.errors?.join(", ") ||
            "Failed to search images on unsplash"
        );
        return reject(err);
      });
  });
};

export const getUnsplashImages = (query) => {
  const page = query?.page || 1;
  const search = query?.search || "";
  const per_page = query?.per_page || 10;

  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/utility/unsplash?pages=${page}&query=${search}&per_page=${per_page}`
    )
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.errors?.join(", ") ||
            "Failed to search images on unsplash"
        );
        return reject(err);
      });
  });
};

export const downloadUnsplashImage = (photo_id, ixid) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/utility/unsplash/download?photo_id=${photo_id}&ixid=${ixid}`)
      .then((res) => {
        if (res?.data?.payload?.message?.length > 0)
          toastr.warning(
            "Error in unsplash download event",
            res?.data?.payload?.message?.join(", ")
          );

        return resolve(res);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.errors?.join(", ") ||
            "Failed to search images on unsplash"
        );
        return reject(err);
      });
  });
};
